import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "truncate" }

import { PropType } from 'vue';
import { VueAttributeClass } from '@/types/attributes-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemName',
  props: {
  name: {
    type: String,
    required: true,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([props.class, "flex flex-grow items-center overflow-hidden"])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(props.name), 1)
  ], 2))
}
}

})